export const ragaScaleGroups = [
  {
    category: "Carnatic Famous Ragas",
    scales: [
      {
        id: "carnatic_mohanam",
        name: "Mohanam",
        arohanam: ["C", "D", "E", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "E", "D", "C"],
      },
      {
        id: "carnatic_hamsadhwani",
        name: "Hamsadhwani",
        arohanam: ["C", "D", "E", "G", "B", "C"],
        avarohanam: ["C", "B", "G", "E", "D", "C"],
      },
      {
        id: "carnatic_hindolam",
        name: "Hindolam",
        arohanam: ["C", "D#", "F", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F", "D#", "C"],
      },
      {
        id: "carnatic_kalyani",
        name: "Kalyani",
        arohanam: ["C", "D", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "carnatic_shankarabharanam",
        name: "Shankarabharanam",
        arohanam: ["C", "D", "E", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_keeravani",
        name: "Keeravani",
        arohanam: ["C", "D", "D#", "F", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F", "D#", "D", "C"],
      },
      {
        id: "carnatic_charukesi",
        name: "Charukesi",
        arohanam: ["C", "D", "E", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_revathi",
        name: "Revathi",
        arohanam: ["C", "C#", "F", "G", "A#", "C"],
        avarohanam: ["C", "A#", "G", "F", "C#", "C"],
      },
      {
        id: "carnatic_abhogi",
        name: "Abhogi",
        arohanam: ["C", "D", "D#", "F", "A", "C"],
        avarohanam: ["C", "A", "F", "D#", "D", "C"],
      },
      {
        id: "carnatic_madhyamavati",
        name: "Madhyamavati",
        arohanam: ["C", "D", "F", "G", "A#", "C"],
        avarohanam: ["C", "A#", "G", "F", "D", "C"],
      },
      {
        id: "carnatic_suddha_dhanyasi",
        name: "Suddha Dhanyasi",
        arohanam: ["C", "D#", "F", "G", "A#", "C"],
        avarohanam: ["C", "A#", "G", "F", "D#", "C"],
      },
      {
        id: "carnatic_amrithavarshini",
        name: "Amrithavarshini",
        arohanam: ["C", "E", "F#", "G", "B", "C"],
        avarohanam: ["C", "B", "G", "F#", "E", "C"],
      },
      {
        id: "carnatic_bilahari",
        name: "Bilahari",
        arohanam: ["C", "D", "E", "G", "A", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_arabhi",
        name: "Arabhi",
        arohanam: ["C", "D", "F", "G", "A", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_kharaharapriya",
        name: "Kharaharapriya",
        arohanam: ["C", "D", "D#", "F", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "carnatic_harikambhoji",
        name: "Harikambhoji",
        arohanam: ["C", "D", "E", "F", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_shanmukhapriya",
        name: "Shanmukhapriya",
        arohanam: ["C", "D", "D#", "F#", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F#", "D#", "D", "C"],
      },
      {
        id: "carnatic_simhendramadhyamam",
        name: "Simhendramadhyamam",
        arohanam: ["C", "D", "D#", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "D#", "D", "C"],
      },
      {
        id: "carnatic_pantuvarali",
        name: "Pantuvarali / Kamavardhini",
        arohanam: ["C", "C#", "E", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "carnatic_vachaspati",
        name: "Vachaspati",
        arohanam: ["C", "D", "E", "F#", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "carnatic_nattai",
        name: "Nattai",
        arohanam: ["C", "D", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "carnatic_begada",
        name: "Begada",
        arohanam: ["C", "D", "E", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_sahana",
        name: "Sahana",
        arohanam: ["C", "D", "D#", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "carnatic_anandabhairavi",
        name: "Anandabhairavi",
        arohanam: ["C", "D", "D#", "F", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "carnatic_todi",
        name: "Hanumatodi",
        arohanam: ["C", "C#", "D#", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "D#", "C#", "C"],
      },
      {
        id: "carnatic_natakurinji",
        name: "Nattakurinji",
        arohanam: ["C", "D", "F", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "F", "D", "C"],
      },
      {
        id: "carnatic_neelambari",
        name: "Neelambari",
        arohanam: ["C", "D", "E", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_surutti",
        name: "Surutti",
        arohanam: ["C", "D", "F", "G", "A", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_ritigowla",
        name: "Ritigowla",
        arohanam: ["C", "D", "D#", "F", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "carnatic_varali",
        name: "Varali",
        arohanam: ["C", "C#", "E", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "carnatic_gowlai",
        name: "Gowlai",
        arohanam: ["C", "D", "F", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_kanada",
        name: "Kanada",
        arohanam: ["C", "D", "D#", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "carnatic_darbari_kanada",
        name: "Darbari Kanada",
        arohanam: ["C", "D", "D#", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "D#", "D", "C"],
      },
      {
        id: "carnatic_hamsanandi",
        name: "Hamsanandi",
        arohanam: ["C", "D#", "E", "F#", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "F#", "E", "D#", "C"],
      },
      {
        id: "carnatic_nalinakanthi",
        name: "Nalinakanthi",
        arohanam: ["C", "D", "E", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "E", "D", "C"],
      },
      {
        id: "carnatic_saraswati",
        name: "Saraswati",
        arohanam: ["C", "D", "E", "F#", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "carnatic_latangi",
        name: "Latangi",
        arohanam: ["C", "D", "E", "F#", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F#", "E", "D", "C"],
      },
      {
        id: "carnatic_gamanashrama",
        name: "Gamanashrama",
        arohanam: ["C", "C#", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "carnatic_nasikabhushani",
        name: "Nasikabhushani",
        arohanam: ["C", "C#", "E", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "E", "C#", "C"],
      },
      {
        id: "carnatic_kosalam",
        name: "Kosalam",
        arohanam: ["C", "D", "E", "F", "G", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_rasikapriya",
        name: "Rasikapriya",
        arohanam: ["C", "C#", "E", "F#", "G#", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G#", "F#", "E", "C#", "C"],
      },
    ],
  },

  {
    category: "Hindustani Famous Ragas",
    scales: [
      {
        id: "hindustani_yaman",
        name: "Yaman",
        arohanam: ["C", "D", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "hindustani_bhairav",
        name: "Bhairav",
        arohanam: ["C", "C#", "E", "F", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F", "E", "C#", "C"],
      },
      {
        id: "hindustani_bhairavi",
        name: "Bhairavi",
        arohanam: ["C", "C#", "D#", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "D#", "C#", "C"],
      },
      {
        id: "hindustani_malkauns",
        name: "Malkauns",
        arohanam: ["C", "D#", "F", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F", "D#", "C"],
      },
      {
        id: "hindustani_bageshri",
        name: "Bageshri",
        arohanam: ["C", "D", "D#", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "D#", "D", "C"],
      },
      {
        id: "hindustani_desh",
        name: "Desh",
        arohanam: ["C", "D", "F", "G", "B", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "hindustani_bhimpalasi",
        name: "Bhimpalasi",
        arohanam: ["C", "D#", "F", "G", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "hindustani_durga",
        name: "Durga",
        arohanam: ["C", "D", "F", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "F", "D", "C"],
      },
      {
        id: "hindustani_bhoopali",
        name: "Bhoopali / Bhupali",
        arohanam: ["C", "D", "E", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "E", "D", "C"],
      },
      {
        id: "hindustani_todi",
        name: "Miyan Ki Todi",
        arohanam: ["C", "C#", "D#", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "D#", "C#", "C"],
      },
      {
        id: "hindustani_marwa",
        name: "Marwa",
        arohanam: ["C", "C#", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "hindustani_lalit",
        name: "Lalit",
        arohanam: ["C", "C#", "E", "F", "F#", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "F#", "F", "E", "C#", "C"],
      },
      {
        id: "hindustani_pahadi",
        name: "Pahadi",
        arohanam: ["C", "D", "E", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "E", "D", "C"],
      },
    ],
  },
  {
    category: "Western Scales / Modes",
    scales: [
      {
        id: "western_major",
        name: "Major / Ionian",
        arohanam: ["C", "D", "E", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "western_natural_minor",
        name: "Natural Minor / Aeolian",
        arohanam: ["C", "D", "D#", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "D#", "D", "C"],
      },
      {
        id: "western_harmonic_minor",
        name: "Harmonic Minor",
        arohanam: ["C", "D", "D#", "F", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F", "D#", "D", "C"],
      },
      {
        id: "western_dorian",
        name: "Dorian",
        arohanam: ["C", "D", "D#", "F", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "western_phrygian",
        name: "Phrygian",
        arohanam: ["C", "C#", "D#", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "D#", "C#", "C"],
      },
      {
        id: "western_lydian",
        name: "Lydian",
        arohanam: ["C", "D", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "western_mixolydian",
        name: "Mixolydian",
        arohanam: ["C", "D", "E", "F", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "western_pentatonic_major",
        name: "Major Pentatonic",
        arohanam: ["C", "D", "E", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "E", "D", "C"],
      },
      {
        id: "western_pentatonic_minor",
        name: "Minor Pentatonic",
        arohanam: ["C", "D#", "F", "G", "A#", "C"],
        avarohanam: ["C", "A#", "G", "F", "D#", "C"],
      },
    ],
  },
  {
    category: "👑 Advanced Indian Classical • Master Ragas",
    scales: [
      {
        id: "carnatic_chalanata",
        name: "Chalanata",
        arohanam: ["C", "C#", "E", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "E", "C#", "C"],
      },
      {
        id: "carnatic_jalarnavam",
        name: "Jalarnavam",
        arohanam: ["C", "C#", "E", "F", "G", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G", "F", "E", "C#", "C"],
      },
      {
        id: "carnatic_jhankaradhwani",
        name: "Jhankaradhwani",
        arohanam: ["C", "C#", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "carnatic_dhatuvardhani",
        name: "Dhatuvardhani",
        arohanam: ["C", "C#", "E", "F#", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F#", "E", "C#", "C"],
      },
      {
        id: "carnatic_naganandini",
        name: "Naganandini",
        arohanam: ["C", "D", "E", "F", "G", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_ragavardhini",
        name: "Ragavardhini",
        arohanam: ["C", "D", "E", "F#", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F#", "E", "D", "C"],
      },
      {
        id: "carnatic_gangeyabhushani",
        name: "Gangeyabhushani",
        arohanam: ["C", "D", "D#", "F#", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F#", "D#", "D", "C"],
      },
      {
        id: "carnatic_vagadheeswari",
        name: "Vagadheeswari",
        arohanam: ["C", "D", "D#", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "carnatic_shulini",
        name: "Shulini",
        arohanam: ["C", "D", "D#", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "D#", "D", "C"],
      },
      {
        id: "carnatic_chitrambari",
        name: "Chitrambari",
        arohanam: ["C", "D", "D#", "F#", "G#", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G#", "F#", "D#", "D", "C"],
      },
      {
        id: "carnatic_sucharitra",
        name: "Sucharitra",
        arohanam: ["C", "D", "E", "F", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F", "E", "D", "C"],
      },
      {
        id: "carnatic_jyotiswarupini",
        name: "Jyotiswarupini",
        arohanam: ["C", "D", "E", "F#", "G#", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G#", "F#", "E", "D", "C"],
      },
      {
        id: "carnatic_dharmavati",
        name: "Dharmavati",
        arohanam: ["C", "D", "D#", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "D#", "D", "C"],
      },
      {
        id: "carnatic_hemavati",
        name: "Hemavati",
        arohanam: ["C", "D", "D#", "F#", "G", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G", "F#", "D#", "D", "C"],
      },
      {
        id: "carnatic_nitimati",
        name: "Nitimati",
        arohanam: ["C", "D", "E", "F#", "G", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G", "F#", "E", "D", "C"],
      },
      {
        id: "carnatic_kantamani",
        name: "Kantamani",
        arohanam: ["C", "C#", "E", "F", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F", "E", "C#", "C"],
      },
      {
        id: "carnatic_ramapriya",
        name: "Ramapriya",
        arohanam: ["C", "C#", "E", "F", "G#", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G#", "F", "E", "C#", "C"],
      },
      {
        id: "carnatic_rishabhapriya",
        name: "Rishabhapriya",
        arohanam: ["C", "C#", "E", "F#", "G", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "carnatic_tanarupi",
        name: "Tanarupi",
        arohanam: ["C", "C#", "D#", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "D#", "C#", "C"],
      },
      {
        id: "carnatic_viswambari",
        name: "Viswambari",
        arohanam: ["C", "C#", "D#", "F", "G", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G", "F", "D#", "C#", "C"],
      },

      {
        id: "hindustani_poorvi",
        name: "Poorvi",
        arohanam: ["C", "C#", "E", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "hindustani_puriya",
        name: "Puriya",
        arohanam: ["C", "C#", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "hindustani_puriya_dhanashree",
        name: "Puriya Dhanashree",
        arohanam: ["C", "C#", "E", "F#", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "hindustani_shree",
        name: "Shree",
        arohanam: ["C", "C#", "E", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "hindustani_patdeep",
        name: "Patdeep",
        arohanam: ["C", "D", "D#", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "hindustani_madhuvanti",
        name: "Madhuvanti",
        arohanam: ["C", "D", "E", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "E", "D", "C"],
      },
      {
        id: "hindustani_jaijaiwanti",
        name: "Jaijaiwanti",
        arohanam: ["C", "D", "E", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "hindustani_jog",
        name: "Jog",
        arohanam: ["C", "D", "D#", "G", "A#", "C"],
        avarohanam: ["C", "A#", "G", "D#", "D", "C"],
      },
      {
        id: "hindustani_jogiya",
        name: "Jogiya",
        arohanam: ["C", "C#", "F", "G", "A#", "C"],
        avarohanam: ["C", "A#", "G", "F", "C#", "C"],
      },
      {
        id: "hindustani_gaud_sarang",
        name: "Gaud Sarang",
        arohanam: ["C", "D", "E", "F#", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "hindustani_miyan_malhar",
        name: "Miyan Malhar",
        arohanam: ["C", "D", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "D", "C"],
      },
      {
        id: "hindustani_megh_malhar",
        name: "Megh Malhar",
        arohanam: ["C", "D", "F", "G", "A#", "C"],
        avarohanam: ["C", "A#", "G", "F", "D", "C"],
      },
      {
        id: "hindustani_gaud_malhar",
        name: "Gaud Malhar",
        arohanam: ["C", "D", "E", "F", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "hindustani_adana",
        name: "Adana",
        arohanam: ["C", "D", "F", "G", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "D", "C"],
      },
      {
        id: "hindustani_shankara",
        name: "Shankara",
        arohanam: ["C", "D", "E", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "E", "D", "C"],
      },
      {
        id: "hindustani_multani",
        name: "Multani",
        arohanam: ["C", "C#", "E", "F#", "G", "A#", "C"],
        avarohanam: ["C", "A#", "G", "F#", "E", "C#", "C"],
      },
      {
        id: "hindustani_sohini",
        name: "Sohini",
        arohanam: ["C", "C#", "E", "F#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "F#", "E", "C#", "C"],
      },
      {
        id: "hindustani_kedar",
        name: "Kedar",
        arohanam: ["C", "D", "F", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "F", "D", "C"],
      },
      {
        id: "hindustani_kaunsi_kanada",
        name: "Kaunsi Kanada",
        arohanam: ["C", "D#", "F", "G", "G#", "C"],
        avarohanam: ["C", "G#", "G", "F", "D#", "C"],
      },
    ],
  },
  {
    category: "🎷 Jazz • Fusion • Progressive & Virtuoso Modes",
    scales: [
      {
        id: "jazz_acoustic_lydian_dominant",
        name: "Acoustic Scale / Lydian Dominant / Lydian b7",
        arohanam: ["C", "D", "E", "F#", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "jazz_mixolydian_b6",
        name: "Mixolydian b6",
        arohanam: ["C", "D", "E", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "E", "D", "C"],
      },
      {
        id: "jazz_locrian_natural2",
        name: "Locrian Natural 2",
        arohanam: ["C", "D", "D#", "F", "F#", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F#", "F", "D#", "D", "C"],
      },
      {
        id: "jazz_lydian_sharp2",
        name: "Lydian #2",
        arohanam: ["C", "D#", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "D#", "C"],
      },
      {
        id: "jazz_lydian_diminished",
        name: "Lydian Diminished",
        arohanam: ["C", "D", "D#", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "D#", "D", "C"],
      },
      {
        id: "jazz_minor_major",
        name: "Minor Major",
        arohanam: ["C", "D", "D#", "F", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F", "D#", "D", "C"],
      },
      {
        id: "jazz_aeolian_dominant",
        name: "Aeolian Dominant",
        arohanam: ["C", "D", "D#", "F", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "jazz_major_locrian",
        name: "Major Locrian",
        arohanam: ["C", "D", "E", "F", "F#", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F#", "F", "E", "D", "C"],
      },
      {
        id: "jazz_ionian_sharp5",
        name: "Ionian #5",
        arohanam: ["C", "D", "E", "F", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F", "E", "D", "C"],
      },
      {
        id: "jazz_dorian_sharp4_romanian_minor",
        name: "Dorian #4 / Romanian Minor",
        arohanam: ["C", "D", "D#", "F#", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F#", "D#", "D", "C"],
      },
      {
        id: "jazz_phrygian_dominant_spanish_gypsy",
        name: "Phrygian Dominant / Spanish Gypsy",
        arohanam: ["C", "C#", "E", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "E", "C#", "C"],
      },
      {
        id: "jazz_double_harmonic_minor",
        name: "Double Harmonic Minor",
        arohanam: ["C", "C#", "E", "F", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F", "E", "C#", "C"],
      },
      {
        id: "jazz_neapolitan_major",
        name: "Neapolitan Major",
        arohanam: ["C", "C#", "D#", "F", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F", "D#", "C#", "C"],
      },
      {
        id: "jazz_neapolitan_minor",
        name: "Neapolitan Minor",
        arohanam: ["C", "C#", "D#", "F", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F", "D#", "C#", "C"],
      },
      {
        id: "jazz_composite_blues",
        name: "Composite Blues",
        arohanam: ["C", "D#", "F", "F#", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F#", "F", "D#", "C"],
      },
      {
        id: "jazz_prometheus_neapolitan",
        name: "Prometheus Neapolitan",
        arohanam: ["C", "C#", "E", "F#", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "F#", "E", "C#", "C"],
      },
      {
        id: "jazz_leading_whole_tone",
        name: "Leading Whole Tone",
        arohanam: ["C", "D", "E", "F#", "G#", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "G#", "F#", "E", "D", "C"],
      },
      {
        id: "jazz_altered_super_locrian",
        name: "Altered Scale / Super Locrian",
        arohanam: ["C", "C#", "D#", "E", "F#", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F#", "E", "D#", "C#", "C"],
      },
      {
        id: "jazz_lydian_augmented",
        name: "Lydian Augmented",
        arohanam: ["C", "D", "E", "F#", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F#", "E", "D", "C"],
      },
      {
        id: "jazz_whole_tone",
        name: "Whole Tone",
        arohanam: ["C", "D", "E", "F#", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F#", "E", "D", "C"],
      },
      {
        id: "jazz_half_whole_diminished",
        name: "Half-Whole Diminished",
        arohanam: ["C", "C#", "D#", "E", "F#", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F#", "E", "D#", "C#", "C"],
      },
      {
        id: "jazz_whole_half_diminished",
        name: "Whole-Half Diminished",
        arohanam: ["C", "D", "D#", "F", "F#", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F#", "F", "D#", "D", "C"],
      },
      {
        id: "jazz_bebop_major",
        name: "Bebop Major",
        arohanam: ["C", "D", "E", "F", "G", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "G", "F", "E", "D", "C"],
      },
      {
        id: "jazz_bebop_minor",
        name: "Bebop Minor",
        arohanam: ["C", "D", "D#", "F", "G", "G#", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G#", "G", "F", "D#", "D", "C"],
      },
      {
        id: "jazz_bebop_dominant",
        name: "Bebop Dominant",
        arohanam: ["C", "D", "E", "F", "G", "A", "A#", "B", "C"],
        avarohanam: ["C", "B", "A#", "A", "G", "F", "E", "D", "C"],
      },
      {
        id: "jazz_eight_tone_spanish",
        name: "Eight Tone Spanish",
        arohanam: ["C", "C#", "D#", "E", "F", "F#", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F#", "F", "E", "D#", "C#", "C"],
      },
      {
        id: "jazz_chromatic_bebop",
        name: "Chromatic Bebop",
        arohanam: [
          "C",
          "C#",
          "D",
          "D#",
          "E",
          "F",
          "F#",
          "G",
          "G#",
          "A",
          "A#",
          "B",
          "C",
        ],
        avarohanam: [
          "C",
          "B",
          "A#",
          "A",
          "G#",
          "G",
          "F#",
          "F",
          "E",
          "D#",
          "D",
          "C#",
          "C",
        ],
      },
      {
        id: "jazz_hexatonic_blues",
        name: "Hexatonic Blues",
        arohanam: ["C", "D#", "F", "F#", "G", "A#", "C"],
        avarohanam: ["C", "A#", "G", "F#", "F", "D#", "C"],
      },
    ],
  },
  {
    category: "🎬 Cinematic Presets",
    scales: [
      {
        id: "zimmer_style",
        name: "Hans Zimmer Style",
        arohanam: ["C", "D", "D#", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "D#", "D", "C"],
      },
      {
        id: "john_williams_style",
        name: "John Williams Style",
        arohanam: ["C", "D", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "dark_fantasy",
        name: "Dark Fantasy",
        arohanam: ["C", "D", "D#", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "D#", "D", "C"],
      },
      {
        id: "scifi_suspense",
        name: "Sci-Fi Suspense",
        arohanam: ["C", "D", "E", "F#", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F#", "E", "D", "C"],
      },
      {
        id: "mystic",
        name: "Mystic",
        arohanam: ["C", "C#", "E", "F", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F", "E", "C#", "C"],
      },
      {
        id: "heroic",
        name: "Heroic",
        arohanam: ["C", "D", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "adventure",
        name: "Adventure",
        arohanam: ["C", "D", "E", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "E", "D", "C"],
      },
      {
        id: "ancient_temple",
        name: "Ancient Temple",
        arohanam: ["C", "C#", "E", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "E", "C#", "C"],
      },
      {
        id: "nordic",
        name: "Nordic",
        arohanam: ["C", "D", "D#", "F", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "viking",
        name: "Viking",
        arohanam: ["C", "D", "D#", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "D#", "D", "C"],
      },
      {
        id: "desert",
        name: "Desert",
        arohanam: ["C", "C#", "E", "F", "G", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "G", "F", "E", "C#", "C"],
      },
      {
        id: "middle_eastern",
        name: "Middle Eastern",
        arohanam: ["C", "C#", "E", "F", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F", "E", "C#", "C"],
      },
      {
        id: "japanese_epic",
        name: "Japanese Epic",
        arohanam: ["C", "D", "D#", "G", "G#", "C"],
        avarohanam: ["C", "G#", "G", "D#", "D", "C"],
      },
      {
        id: "chinese_epic",
        name: "Chinese Epic",
        arohanam: ["C", "D", "E", "G", "A", "C"],
        avarohanam: ["C", "A", "G", "E", "D", "C"],
      },
      {
        id: "pirate",
        name: "Pirate",
        arohanam: ["C", "D", "D#", "F", "G", "A", "A#", "C"],
        avarohanam: ["C", "A#", "A", "G", "F", "D#", "D", "C"],
      },
      {
        id: "horror",
        name: "Horror",
        arohanam: ["C", "C#", "D#", "F", "F#", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F#", "F", "D#", "C#", "C"],
      },
      {
        id: "mystery",
        name: "Mystery",
        arohanam: ["C", "D", "E", "F#", "G#", "A#", "C"],
        avarohanam: ["C", "A#", "G#", "F#", "E", "D", "C"],
      },
      {
        id: "dream",
        name: "Dream",
        arohanam: ["C", "D", "E", "F#", "G", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G", "F#", "E", "D", "C"],
      },
      {
        id: "celestial",
        name: "Celestial",
        arohanam: ["C", "D", "E", "F#", "G#", "A", "B", "C"],
        avarohanam: ["C", "B", "A", "G#", "F#", "E", "D", "C"],
      },
      {
        id: "apocalyptic",
        name: "Apocalyptic",
        arohanam: ["C", "D", "D#", "F#", "G", "G#", "B", "C"],
        avarohanam: ["C", "B", "G#", "G", "F#", "D#", "D", "C"],
      },
    ],
  },
];

export const findScaleById = (scaleId) => {
  for (const group of ragaScaleGroups) {
    const found = group.scales.find((scale) => scale.id === scaleId);
    if (found) return found;
  }
  return null;
};
